import { CommonModule } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { ServerRepresentedEvent } from '@app/modules/events/models/event.model'
import { EditorComponent } from '@app/modules/shared/components/editor/editor.component'
import { NbDialogRef, NbSpinnerModule } from '@nebular/theme'
import { Registration } from '../../models/registration.model'
import { DatabaseService } from '../../services/database.service'

@Component({
  selector: 'ngx-revision-request-modal',
  templateUrl: './revision-request-modal.component.html',
  styleUrls: ['./revision-request-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, EditorComponent, NbSpinnerModule]
})
export class RevisionRequestModalComponent implements OnInit {
  @Input() registrant: Registration
  @Input() registrants: Array<{
    fields: {
      fullname: string
      email: string
    }
  }>
  @Input() event: ServerRepresentedEvent
  @Input() isBulkMode = false
  @Input() count = 0

  email: {
    subject: string
    message: string
    registrationButtonContent: string
  }
  loaded = false

  subjectText = 'Attention: We need an adjustment to approve your registration'

  templateOptions = ''
  registrationButtonContent = 'Edit Registration'

  constructor(private dialogRef: NbDialogRef<RevisionRequestModalComponent>, private databaseService: DatabaseService) {}

  ngOnInit() {
    let firstname = ''
    if (!this.isBulkMode && this.registrant) {
      const fullname = this.registrant.fields.fullname
      if (fullname?.includes('. ')) {
        const parts = fullname.split('. ')
        firstname = parts[parts.length - 1].split(' ')[0]
      } else {
        firstname = fullname?.split(' ')[0] ?? ''
      }
    }

    // Get single template
    this.templateOptions = this.getTemplateOptions(this.isBulkMode, firstname, this.event.name)
    // Initialize with the template
    this.email = {
      subject: this.subjectText,
      message: this.templateOptions,
      registrationButtonContent: this.registrationButtonContent
    }

    setTimeout(() => {
      this.loaded = true
    }, 500)
  }

  /**
   * Updates the email message with selected value
   * @param value string
   */
  update(value: string) {
    this.email.message = value
  }

  /**
   * Updates the email message with selected value
   */
  updateEmailMessage() {
    if (!this.email.message) return
    const parser = new DOMParser()
    const doc = parser.parseFromString(this.email.message, 'text/html')

    const images = doc.querySelectorAll('img')
    images.forEach((image) => (image.style.maxWidth = '100%'))

    const headers = doc.querySelectorAll('h1,h2,h3,h4,h5,h6')
    headers.forEach((header) => ((header as HTMLElement).style.lineHeight = '1em'))

    const blockquotes = doc.querySelectorAll('blockquote')
    blockquotes.forEach((blockquote) => {
      blockquote.style.borderLeft = '4px solid #ccc'
      blockquote.style.paddingLeft = '16px'
      blockquote.style.marginTop = '5px 0'
      blockquote.style.fontWeight = 'bold'
    })

    const lists = doc.querySelectorAll('ul,ol')
    lists.forEach((list) => ((list as HTMLElement).style.paddingRight = '1.5em'))

    const listItems = doc.querySelectorAll('ul li')
    listItems.forEach((li) => ((li as HTMLElement).style.listStyleType = 'disc'))

    this.email.message = doc.body.innerHTML
  }

  close() {
    this.dialogRef.close()
  }

  send() {
    this.email.registrationButtonContent = this.registrationButtonContent
    this.databaseService.email = this.email
    this.dialogRef.close(this.email)
    setTimeout(() => {
      this.updateEmailMessage()
      this.databaseService.email = this.email
      this.dialogRef.close(this.email)
    })
  }

  editorOnBlur(event: string) {
    this.email.message = event
  }

  updateRegistrationButtonContent(event: Event) {
    const element = event.target as HTMLSpanElement
    const content = element.innerText.trim()

    if (content === '') {
      this.registrationButtonContent = 'Edit Registration'
      element.innerText = 'Edit Registration'
    } else {
      this.registrationButtonContent = content
    }
  }

  getTemplateOptions(isBulkMode: boolean, firstname: string, eventName: string): string {
    const namePlaceholder = isBulkMode ? '{{firstname}}' : firstname
    return `<p>Dear ${namePlaceholder},</p>
      <p style="line-height:1.3em;">Thank you for your interest in our event. We have reviewed your registration and would like to request some revisions before we can approve your entry.</p>
      <p style="line-height:1.3em;">Please update the following information in your registration:</p>
      <span style="font-style: italic; background-color: #ffff00; line-height:1.3em;">[Provide specific information on what needs to be revised.]</span>
      <p style="line-height:1.3em;">Please click the "Edit Registration" button below to update your entry.</p>
      <p style="line-height:1.3em;">Thank you for your attention to this matter.</p>
      <p style="line-height:1.3em;">Best regards,</p>
      <span style="font-weight: 500; line-height:1.3em;">${eventName}</span> team`
  }
}
